<template>
    <div v-loading.fullscreen.lock="loading" class="container-top" :class="{'auth' : $route.path === '/auth'}">
        <page-header v-if="passPath.indexOf($route.path) === -1"></page-header>
        <router-view/>
        <side-menu  v-if="getAdminType() && UserInfo.hasOwnProperty('mb_no')" ></side-menu>
    </div>

</template>

<script>

import alertMixins from "@/mixins/alertMixins";
import AuthMixins from "@/mixins/AuthMixins";
import EventBus from "@/utils/event-bus";

export default {
    name: "App",
    mixins: [alertMixins, AuthMixins],
    components: {
    },
    provide() {
        return {
            changeLoading: this.changeLoading,
        }
    },
    props: {},
    data() {
        return {
            passPath: ['/auth'],
            loading: false,
        }
    },
    created() {
        this.$store.dispatch('area/setAreaDong');
        this.$store.dispatch('area/setAreaSi');
        // this.$store.dispatch('so/setSoData');
        this.$store.dispatch('soInfo/setSoInfo');
                // this.$store.dispatch('authority/setOneDepth');
    },
    mounted() {
        EventBus.$on('apiLoading', this.changeLoading)
        EventBus.$on('changeLoading', this.changeLoading)
        document.querySelector("div#app").addEventListener('scrollend', this.handleScroll);
    },
    beforeUnmount() {
        EventBus.$off('apiLoading')
        EventBus.$off('changeLoading')
        document.querySelector("div#app").removeEventListener('scrollend', this.handleScroll);
    },
    unmounted() {
    },
    computed: {
        UserInfo() {
            return this.$store.state.userInfo.UserInfo;
        }
    },
    methods: {
        changeLoading(value) {
            this.loading = value;
            return new Promise((resolve, reject) => {
                setTimeout(() => {
                    resolve(true);
                }, 50)
            })
        },
        handleScroll() {
            EventBus.$emit("resetLogoutTimer", true);
        }
    },
}
</script>

<style lang="scss">
@import "./assets/scss/index.scss";
</style>
